import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'
import { injectIntl, FormattedMessage } from 'react-intl'
import { isMobile } from 'react-device-detect'

import { Table, Icon, Button, Collapse, Row, Col } from 'core/components/ui'
import { font, greys } from 'assets/themes/theme-default'
import * as constants from '../VehicleAreas/constants'

const { Panel } = Collapse

const TotalDamages = styled.span`
  background: ${props => props.theme.colors.color1.bg};
  color: ${greys.light4};
  display: inline-block;
  border-radius: 20px;
  font-size: ${font.size.sm};
  line-height: 20px;
  height: 20px;
  width: 20px;
  text-align: center;
`

const TableDefault = styled(Table)`
  & tr > td {
    padding: ${isMobile ? '0 6px' : '0 16px'} !important;
  }
  .ant-collapse-borderless > .ant-collapse-item {
    border: none;
  }
`

const DatasRow = styled.div`
  span {
    display: block;
    font-size: ${font.size.sm};
    color: ${greys.dark3};
    padding: ${isMobile ? '0' : '0 0 10px 30px'};
    line-height: normal;
    :first-child {
      padding: 0;
      font-size: ${font.size.base};
      color: ${greys.dark1};
    }
  }
`

const LinkButton = styled(Button)`
  span {
    text-decoration: underline;
  }
`

const CollapseHeader = styled(Row)`
  // font-size: ${font.size.sm};
  padding: 5px 0;
`

const StyledPanel = styled(Panel)`
  & {
    border: none;
    button {
      font-size: ${font.size.sm};
    }
  }
  .ant-collapse-content-box {
    border: none;
    padding: 16px 0 16px 16px;
  }
  .part-name {
    font-weight: ${font.weight.bold};
    border: solid;
    border-color: ${greys.dark1};
    padding: 5px 0;
    border-width: 0 0 1px 0;
  }
`
const minusIcon = <Icon type="minus" />
const plusIcon = <Icon type="plus" />

const CollapseAreas = props => {
  const { sections, onShowDamagePicturesModal, onDeleteDefect, intl } = props
  const deleteDefect = defect => {
    onDeleteDefect(defect)
  }

  const dataSource =
    sections &&
    sections
      .filter(el => el.damages && el.damages.length > 0)
      .map(section => {
        const { label, zones, damages, id } = section

        const getTotal = () => {
          let totalDamages = 0
          let totalVisuals = 0
          let totalExclVatPrice = 0
          let totalInclVatPrice = 0

          zones.forEach(element => {
            if (element.decorator.value) totalDamages += element.decorator.value
          })

          if (damages) {
            damages.forEach(element => {
              if (element.exclVatPrice) totalExclVatPrice += element.exclVatPrice
              if (element.inclVatPrice) totalInclVatPrice += element.inclVatPrice
              if (element.pictures && element.pictures.length)
                totalVisuals += element.pictures.length
            })
          }

          return {
            visuals:
              totalVisuals > 0 ? (
                <>
                  {totalVisuals}{' '}
                  {intl.formatMessage(
                    { id: 'tradeIn-defaults-table-area-value-visuals' },
                    { value: totalVisuals }
                  )}
                </>
              ) : null,
            damages: totalDamages > 0 ? <TotalDamages>{totalDamages}</TotalDamages> : null,
            exclVatPrice: totalExclVatPrice > 0 ? totalExclVatPrice : null,
            inclVatPrice: totalInclVatPrice > 0 ? totalInclVatPrice : null
          }
        }

        const total = getTotal()

        return {
          key: id,
          label,
          totalVisuals: total.visuals,
          totalDamages: total.damages,
          totalExclVatPrice: total.exclVatPrice,
          totalInclVatPrice: total.inclVatPrice,
          damages
        }
      })

  const expandedRowRender = section => {
    const { damages } = section

    const columns = [
      {
        title: intl.formatMessage({ id: 'tradeIn-defaults-table-area-label-1' }),
        render: record => {
          if (
            section.key === constants.SECTIONS.SADDLERY ||
            section.key === constants.SECTIONS.OTHER
          )
            return record.defectWording

          return (
            <DatasRow>
              <span>{record.defectWording}</span>
            </DatasRow>
          )
        },
        key: 'wording'
      },
      {
        render: record => (
          <LinkButton type="link" onClick={() => onShowDamagePicturesModal(record)}>
            {intl.formatMessage({
              id:
                record.pictures && record.pictures.length > 0
                  ? 'tradeIn-defaults-manage-visuals'
                  : 'tradeIn-defaults-add-visual'
            })}{' '}
            {record.pictures && record.pictures.length > 0 && `(${record.pictures.length})`}
          </LinkButton>
        ),
        key: 'visuals'
      },
      {
        align: 'center',
        key: 'action',
        render: record => (
          <LinkButton type="link" onClick={() => deleteDefect(record)} style={{ width: '20px' }}>
            <Icon type="delete" style={{ fontSize: '16px' }} />
          </LinkButton>
        )
      }
    ]
    const headerRender = part => (
      <CollapseHeader>
        <Col span={8}>
          <FormattedMessage id={part.label.props.id} />
        </Col>
        <Col span={8} justify="middle">
          {part.totalVisuals && part.totalVisuals.props.children}
        </Col>
        <Col span={8} justify="end" style={{ textAlign: 'right' }}>
          <TotalDamages>{part.totalDamages.props.children}</TotalDamages>
        </Col>
      </CollapseHeader>
    )

    return (
      <>
        <>
          <Collapse
            expandIcon={({ isActive }) => (isActive ? minusIcon : plusIcon)}
            key={1}
            bordered={false}
            expandIconPosition="left"
          >
            <StyledPanel header={headerRender(section)} key="1">
              {_.uniqBy(section.damages, 'sectionId').map(damage => (
                <Row>
                  <Col span="24" className="part-name">
                    {damage.sectionWording}
                  </Col>
                  <Col span="24">
                    <TableDefault
                      columns={columns}
                      dataSource={damages.filter(el => el.sectionId === damage.sectionId)}
                      rowKey="id"
                      pagination={false}
                      showHeader={false}
                    />
                  </Col>
                </Row>
              ))}
            </StyledPanel>
          </Collapse>
        </>
      </>
    )
  }

  return <>{dataSource.map(section => expandedRowRender(section, dataSource))}</>
}
CollapseAreas.defaultProps = {
  sections: [],
  onDeleteDefect: null,
  onShowDamagePicturesModal: null
}

CollapseAreas.propTypes = {
  intl: PropTypes.shape().isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape()),
  onDeleteDefect: PropTypes.func,
  onShowDamagePicturesModal: PropTypes.func
}

export default injectIntl(CollapseAreas)
